import { adminProQueryOptions } from "api/queries/admin";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [adminProQueryOptions(input.id)];
